
export class LastActive {
    active: number[] = [];
    counter = 0;

    start() {
        this.counter++;
        const id = this.counter;
        this.active.push(id);

        return {
            finishAndIsLast: () => {
                this.active = this.active.filter(v => v !== id);
                return this.active.length === 0;
            },
            finish: () => {
                this.active = this.active.filter(v => v !== id);
            }
        }
    }
}